import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Breadcrumbs, Button, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  blue,
  gray,
  primarycolor,
  secondaryButtonnBackground
} from '../../../constants/Colors';
import {
  buttonFont,
  cardCentering,
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
} from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import CompleteCard from '../../uiParts/CompleteCard';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  breadcrumbs: {
    '.MuiBreadcrumbs-separator': {
      margin: '0 8px 2px 8px'
    },
    display: 'flex',
    fontSize: '12px',
    margin: '12px 0 0 24px'
  },
  breadcrumbsText: {
    color: gray,
    fontSize: '12px'
  },
  button: {
    '@media screen and (max-width:480px)': {
      width: 309
    },
    height: 42,
    width: 400
  },
  buttonFont,
  card: {
    '@media screen and (max-width:960px)': {
      marginTop: '101px'
    },
    alignItems: 'center',
    display: 'flex',
    flex: 1
  },
  cardCentering,
  icon: {
    color: blue,
    fontSize: '56px',
    paddingBottom: '24px'
  },
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
};

const AgentMypageStaffDeleteComplete: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.agent.mypageStaffDeleteComplete');
  });

  const navigate = useNavigate();
  const icon = <EmailOutlinedIcon sx={styles.icon} />;
  const text = t('staff.delete.complete');
  const description = t('staff.delete.completeDesc');

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      href="/main/agent/mypage/staff"
      sx={styles.breadcrumbsText}
    >
      {t('staff.title')}
    </Link>,
    <Typography key="2" sx={styles.breadcrumbsText}>
      {t('staff.edit.title')}
    </Typography>,
    <Typography key="3" sx={styles.breadcrumbsText}>
      {t('staff.delete.title')}
    </Typography>
  ];

  const button = (
    <Button
      variant="contained"
      sx={[secondaryButtonnBackground, styles.button]}
      onClick={() => {
        navigate('/agent/mypage/staff');
      }}
    >
      <Typography component="div" color={primarycolor} sx={styles.buttonFont}>
        {t('staff.delete.completeButton')}
      </Typography>
    </Button>
  );

  return (
    <>
      <Typography component="div" sx={styles.mypageWrapper}>
        <Sidebar screenType={screenType.agent} />
        <Typography
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            position: 'static',
            width: '100%'
          }}
        >
          <Typography sx={styles.mypageHeader} component="div">
            <Typography sx={styles.mypageHeaderTitle}>
              {t('staff.delete.title')}
            </Typography>
          </Typography>
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
            sx={styles.breadcrumbs}
          >
            {breadcrumbs}
          </Breadcrumbs>
          <Typography component="div" sx={styles.card}>
            <CompleteCard
              icon={icon}
              text={text}
              description={description}
              button={button}
            />
          </Typography>
        </Typography>
      </Typography>
    </>
  );
};

export default AgentMypageStaffDeleteComplete;
